import React from "react";
import SVG from "react-inlinesvg";

export const SelectionTabButton = ({
  buttonClass,
  onClick,
  IconButtonClass,
  buttonIcon,
  buttonText,
}) => {
  return (
    <React.Fragment>
      <button
        className={`top-tab-button-section ${buttonClass}`}
        onClick={onClick}
      >
        <SVG src={buttonIcon} alt="Service Icon" title="Services" />
        {buttonText}
      </button>
    </React.Fragment>
  );
};

export const ArrowIconTabButton = ({
  buttonClass,
  onClick,
  buttonIconDisplay,
}) => {
  return (
    <React.Fragment>
      <button
        className={`small-tab-button-section ${buttonClass}`}
        onClick={onClick}
      >
        {buttonIconDisplay ? (
          <i className="fa fa-angle-left" aria-hidden="true"></i>
        ) : (
          <i className="fa fa-angle-right" aria-hidden="true"></i>
        )}
      </button>
    </React.Fragment>
  );
};
